export default "__VITE_ASSET__BREDCuDA__"